<template>
  <div class="templateBigScreen4">
    <div class="largeScreenContent">
      <div class="header">
        <Screen4Header></Screen4Header>
      </div>
      <div class="content-wrap">
        <div class="left-content-wrap">
          <LeftContent :dataDetail="dataDetail"></LeftContent>
          <Map :list="dataDetail?.siteCityList"></Map>
        </div>
        <div class="right-content-wrap">
          <RightContent :dataDetail="dataDetail"></RightContent>
        </div>
      </div>
      <!-- <img
        alt=""
        src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/tempSelect/templateScreenImg4.png"
        style="width: 100%; height: 100%"
      /> -->
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, onMounted, inject, provide } from "vue";
import XEUtils from "xe-utils";
import Map from "./component/templateBigScreen4/map.vue";
import Screen4Header from "./component/templateBigScreen4/screen4-header.vue";
import LeftContent from "./component/templateBigScreen4/left-content.vue";
import RightContent from "./component/templateBigScreen4/right-content.vue";
import { getMainKanbanDataApiV2 } from "@/api/modules/project";

const receiveTemplateId = inject("templateId");
const receiveProjectModuleId = inject("projectModuleId"); // 默认值为21
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';

// 页面自适应***************************************************************************

const dataDetail = ref(null);
const getData = () => {
  getMainKanbanDataApiV2({
    moduleId: receiveProjectModuleId.value,
    templateId: receiveTemplateId.value,
  }).then((res) => {
    if (res.data.code == 200) {
      if (!XEUtils.isEmpty(res.data.data.warnLogList)) {
        res.data.data.warnLogList = res.data.data.warnLogList.filter((item) => {
          return item.level != 5;
        });
      }

      dataDetail.value = res.data.data;
    }
  });
};

provide("refreshData", getData);

onMounted(() => {
  getData();
});
</script>

<style lang="less" scoped>
.templateBigScreen4 {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;

  .largeScreenContent {
    width: 1920px;
    height: 1080px;
    transform-origin: 0% 0%;
    position: relative;
    background: url("https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/background.png") no-repeat 0 0;
    background-size: 100% 100%;
    z-index: 1;
    display: flex;
    flex-direction: column;
  }
}
.content-wrap {
  flex: 1;
  position: relative;
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  .left-content-wrap {
    flex: 1;
    position: relative;
  }
  .right-content-wrap {
    padding-left: 20px;
  }
}
</style>
